import React, { memo } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Form,
  FormGroup,
  Badge,
  Row,
} from "reactstrap";
import IntlMessages from "../../../helpers/IntlMessages";
import PerfectScrollbar from "react-perfect-scrollbar";
import { AddCommaNumber } from "../../../helpers/Utils";
import PriceInput from "../../../components/common/PriceInput";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Select from "react-select";
import Creatable from "../../../components/common/CreatableSelect";
import DatePicker from "react-datepicker";
import moment from "moment";
import { calculateAveragePurchasePrice } from "../../../helpers/stockCost";

const ContentComponent = ({
  title,
  isOpen,
  toggle,
  onSubmit,
  values,
  data,
  data_providers = [],
  setting,
  onChange,
  loading = false,
  allowSelectStock = false,
}) => {
  const selectedStock = data?.find((d) => d.id === values.id);
  const averagePurchasePrice = calculateAveragePurchasePrice({
    stock: selectedStock,
    importQuantity: values.new_count,
    importUnitPrice: values.unit_price,
  });

  // Tạo danh sách options cho nhà cung cấp
  let items_select = [];
  items_select = data_providers.map((item) => ({
    label: item.name,
    value: item.name,
  }));

  // Tính tổng tiền và còn nợ
  const totalValue =
    Number(String(values.unit_price || 0).replace(/\./g, "")) *
    Number(values.new_count || 0);
  const remaining = Math.max(
    0,
    totalValue - Number(String(values.price_outcome || 0).replace(/\./g, "")),
  );

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      // centered
      backdrop="static"
      autoFocus={false}
    >
      <Form onSubmit={(e) => onSubmit(e)}>
        <ModalHeader toggle={toggle}>
          <div className="d-flex align-items-center">
            <span>{title}</span>
          </div>
        </ModalHeader>
        <ModalBody className="py-3 px-4">
          <PerfectScrollbar
            options={{
              suppressScrollX: true,
              wheelPropagation: false,
            }}
            style={{
              maxHeight: "calc(80vh - 130px)",
              overflowX: "hidden",
              paddingRight: "6px",
            }}
          >
            <Row>
              {/* Cột 1: Thông tin nguyên liệu & Số lượng bổ sung */}
              <Colxx xxs="12" md="6" className="pr-md-3">
                <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                  <i
                    className="simple-icon-basket text-primary mr-2 font-weight-bold"
                    style={{ fontSize: "1.1rem" }}
                  />
                  <h6 className="mb-0 font-weight-bold text-primary">
                    Nguyên liệu & Số lượng bổ sung
                  </h6>
                </div>

                <Row>
                  <Colxx xxs="12" sm="8" className="pr-sm-1">
                    <FormGroup className="has-float-label">
                      <Label for="name" className="text-muted">
                        <IntlMessages id="stock.name" />
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      {allowSelectStock ? (
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          placeholder="Chọn nguyên liệu..."
                          options={(data || []).map((item) => ({
                            label: item.name,
                            value: item.id,
                            item: item,
                          }))}
                          value={
                            values.id
                              ? { label: values.name, value: values.id }
                              : null
                          }
                          onChange={(selectedOption) => {
                            const item = selectedOption
                              ? selectedOption.item
                              : null;
                            onChange(item, "selected_stock");
                          }}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                        />
                      ) : (
                        <Input
                          type="text"
                          name="name"
                          id="name"
                          value={values.name}
                          disabled={true}
                        />
                      )}
                    </FormGroup>
                  </Colxx>
                  <Colxx xxs="12" sm="4" className="pl-sm-1">
                    <FormGroup className="has-float-label">
                      <Label for="sku" className="text-muted">
                        Mã SKU
                      </Label>
                      <Input
                        disabled
                        type="text"
                        name="sku"
                        id="sku"
                        value={values.sku}
                      />
                    </FormGroup>
                  </Colxx>
                </Row>

                <FormGroup className="d-flex align-items-center justify-content-between p-2 rounded bg-light border">
                  <span className="text-muted font-weight-semibold">
                    Giá mua trung bình:
                  </span>
                  <Badge color="primary" pill style={{ fontSize: "0.85rem" }}>
                    {AddCommaNumber(Math.round(averagePurchasePrice))} đ
                  </Badge>
                </FormGroup>

                <Row>
                  <Colxx xxs="12" sm="6" className="pr-sm-1">
                    <FormGroup className="has-float-label">
                      <Label for="unit_price" className="text-muted">
                        <IntlMessages id="stock.unit-price-new" />
                        {values.unit ? ` / ${values.unit}` : null}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <PriceInput
                        autoFocus={true}
                        name="unit_price"
                        id="unit_price"
                        value={values.unit_price}
                        onChange={onChange}
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx xxs="12" sm="6" className="pl-sm-1">
                    <FormGroup className="has-float-label">
                      <Label for="update_count" className="text-muted">
                        <IntlMessages id="stock.count" />
                        {values.unit ? ` (${values.unit})` : null}
                        <span style={{ color: "red" }}>*</span>
                      </Label>
                      <Input
                        name="new_count"
                        id="update_count"
                        type="number"
                        step="any"
                        value={values.new_count}
                        placeholder={0}
                        onChange={onChange}
                      />
                    </FormGroup>
                  </Colxx>
                </Row>

                <div className="border rounded px-3 py-2 mb-3 d-flex justify-content-between align-items-center bg-light">
                  <div>
                    <small className="d-block text-muted">
                      Giá trị bổ sung dự kiến
                    </small>
                    <small className="text-muted">
                      Đơn giá x Số lượng bổ sung
                    </small>
                  </div>
                  <strong className="h6 mb-0 text-primary">
                    {AddCommaNumber(Math.round(totalValue || 0))} đ
                  </strong>
                </div>
              </Colxx>

              {/* Cột 2: Lô hàng & Nhà cung cấp */}
              <Colxx xxs="12" md="6" className="pl-md-3">
                <div className="d-flex align-items-center mb-3 pb-2 border-bottom">
                  <i
                    className="simple-icon-truck text-primary mr-2 font-weight-bold"
                    style={{ fontSize: "1.1rem" }}
                  />
                  <h6 className="mb-0 font-weight-bold text-primary">
                    Thông tin lô & Nhà cung cấp
                  </h6>
                </div>

                <Row>
                  <Colxx xxs="12" sm="6" className="pr-sm-1">
                    <FormGroup className="has-float-label">
                      <Label for="quick_batch_code" className="text-muted">
                        Mã lô
                      </Label>
                      <Input
                        type="text"
                        name="batch_code"
                        id="quick_batch_code"
                        value={values.batch_code || ""}
                        onChange={onChange}
                        placeholder="VD: LOT-2026-001"
                      />
                    </FormGroup>
                  </Colxx>
                  <Colxx xxs="12" sm="6" className="pl-sm-1">
                    <FormGroup className="has-float-label">
                      <Label
                        for="quick_storage_location"
                        className="text-muted"
                      >
                        Vị trí lưu kho
                      </Label>
                      <Input
                        type="text"
                        name="storage_location"
                        id="quick_storage_location"
                        value={values.storage_location || ""}
                        onChange={onChange}
                        placeholder="VD: Kệ A1, tủ lạnh 2"
                      />
                    </FormGroup>
                  </Colxx>
                </Row>

                {/* Hạn sử dụng */}
                <FormGroup className="has-float-label">
                  <Label for="expiry_date" className="text-muted">
                    Hạn sử dụng (nếu có)
                  </Label>
                  <DatePicker
                    name="expiry_date"
                    id="expiry_date"
                    selected={
                      values.expiry_date ? moment(values.expiry_date) : null
                    }
                    onChange={(date) => onChange(date, "expiry_date")}
                    dateFormat="DD-MM-YYYY"
                    minDate={moment()}
                    placeholderText="DD-MM-YYYY"
                    className="form-control"
                    isClearable
                  />
                </FormGroup>

                {/* Nhà cung cấp */}
                <FormGroup className="has-float-label">
                  <Label className="text-muted">
                    <IntlMessages id="company-provider.name" />
                  </Label>
                  <Creatable
                    placeholder={"Chọn hoặc tạo mới nhà cung cấp"}
                    name="items_selected"
                    id="items_selected"
                    onChange={(val) => onChange(val, "items_selected")}
                    value={values.items_selected}
                    options={items_select}
                    formatCreateLabel={(inputValue) =>
                      `Tạo mới: "${inputValue}"`
                    }
                    isClearable
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </FormGroup>

                {/* Hiển thị fields thanh toán khi đã chọn nhà cung cấp */}
                {values.items_selected ? (
                  <Row>
                    <Colxx xxs="6" className="pr-1">
                      <FormGroup className="has-float-label">
                        <Label className="text-muted">Đã trả</Label>
                        <PriceInput
                          name="price_outcome"
                          id="price_outcome"
                          value={values.price_outcome}
                          onChange={onChange}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx xxs="6" className="pl-1">
                      <FormGroup className="has-float-label">
                        <Label className="text-muted">Còn nợ</Label>
                        <Input disabled value={AddCommaNumber(remaining)} />
                      </FormGroup>
                    </Colxx>
                  </Row>
                ) : null}

                {/* Ghi chú nhập kho */}
                <FormGroup className="has-float-label">
                  <Label for="quick_stock_note" className="text-muted">
                    Ghi chú nhập kho
                  </Label>
                  <Input
                    type="textarea"
                    rows="3"
                    name="stock_note"
                    id="quick_stock_note"
                    value={values.stock_note || ""}
                    onChange={onChange}
                    placeholder="Ghi chú tình trạng hàng, lý do nhập..."
                  />
                </FormGroup>
              </Colxx>
            </Row>
          </PerfectScrollbar>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button
            color="outline-secondary"
            type="button"
            onClick={toggle}
            className="mr-2"
          >
            <IntlMessages id="general.btn-cancel" />
          </Button>
          <Button color="primary" type="button" onClick={onSubmit} disabled={loading}>
            <IntlMessages id="general.btn-add" />
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default memo(ContentComponent);
